import { render, staticRenderFns } from "./processModel.vue?vue&type=template&id=619e5737&scoped=true"
import script from "./processModel.vue?vue&type=script&lang=js"
export * from "./processModel.vue?vue&type=script&lang=js"
import style0 from "./processModel.vue?vue&type=style&index=0&id=619e5737&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619e5737",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('619e5737')) {
      api.createRecord('619e5737', component.options)
    } else {
      api.reload('619e5737', component.options)
    }
    module.hot.accept("./processModel.vue?vue&type=template&id=619e5737&scoped=true", function () {
      api.rerender('619e5737', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/mainFrom/processModel.vue"
export default component.exports